/* eslint-disable */
// Generated by GitHub Copilot
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { FaGears, FaCalendarDay, FaUser } from "react-icons/fa6";
import dayjs from "dayjs";
import "./WorkflowHistoryViewer.css";

const relativeTime = require("dayjs/plugin/relativeTime");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
const advancedFormat = require("dayjs/plugin/advancedFormat");

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);

const dateFormat = "MM/DD/YYYY HH:mm z";
const tz = "America/New_York";

function WorkflowHistoryViewer(props) {
  const workflowHistory = props.workflowHistory || [];

  // Handle empty state
  if (!workflowHistory || workflowHistory.length === 0) {
    return (
      <Container>
        <Row>
          <Col>
            <Card className="text-center">
              <Card.Body>
                <FaGears className="mb-2 text-muted" size={24} />
                <Card.Text className="text-muted">
                  No PagerDuty workflows have been executed.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      <Row>
        <Col>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="text-muted">
              {workflowHistory.length} workflow
              {workflowHistory.length !== 1 ? "s" : ""} executed
            </span>
          </div>
        </Col>
      </Row>

      {workflowHistory.map((invocation, index) => {
        const executed = dayjs.unix(invocation.invocation).tz(tz);

        return (
          <Row key={`${invocation.workflow.value}-${index}`} className="mb-2">
            <Col>
              <Card className="workflow-card">
                <Card.Body className="py-2">
                  <Row className="align-items-center">
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <div className="d-flex align-items-center">
                        <Badge bg="success" className="me-2">
                          <FaGears className="me-1" />
                          PD
                        </Badge>
                        <strong>{invocation.workflow.label}</strong>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={5} lg={4} xl={4}>
                      <div className="d-flex align-items-center text-muted">
                        <FaCalendarDay className="me-1" />
                        <span>{executed.format(dateFormat)}</span>
                        <span className="ms-2">({executed.fromNow()})</span>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={4} xl={4}>
                      <div className="d-flex align-items-center text-muted">
                        <FaUser className="me-1" />
                        <span>{invocation.agent}</span>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        );
      })}
    </Container>
  );
}

export default WorkflowHistoryViewer;
